import type { Facet } from '@jane/search/data-access';
import type { Store } from '@jane/shared/types';

export const getValidFeelings = (store: Store, feelings: Facet = {}) =>
  Object.fromEntries(
    Object.entries(feelings).filter(
      ([feelings]) =>
        !store.disabled_feeling_and_activity_tags.includes(feelings)
    )
  );
